import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";
import { formatDate, formatDuration, formatViews } from "@/lib/videos";

export default function RelatedVideoList({ videos }: { videos: VideoItem[] }) {
  return (
    <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-end justify-between gap-3">
        <div>
          <p className="font-label text-[11px] font-semibold uppercase tracking-[0.18em] text-primary-600">
            Watch next
          </p>
          <h2 className="mt-1 font-heading text-lg font-extrabold text-foreground-950">相关推荐</h2>
        </div>
        <span className="font-label text-[11px] text-foreground-400">按标签匹配</span>
      </div>

      <div className="mt-4 flex flex-col gap-3">
        {videos.map((video) => (
          <Link
            key={video.id}
            to={`/video/${video.id}`}
            className="group flex items-start gap-3 rounded-lg p-1.5 transition-colors hover:bg-background-100"
          >
            <div className="relative aspect-video w-[118px] shrink-0 overflow-hidden rounded-md bg-background-200">
              <img
                src={video.cover}
                alt={video.title}
                title={`${video.title} - 茄子视频相关推荐`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute bottom-1 right-1 rounded bg-foreground-950/75 px-1 font-label text-[10px] text-background-50">
                {formatDuration(video.duration)}
              </span>
            </div>
            <div className="min-w-0 flex-1">
              <p className="line-clamp-2 text-[13px] font-medium leading-snug text-foreground-900 transition-colors group-hover:text-primary-600">
                {video.title}
              </p>
              <p className="mt-1.5 flex flex-wrap items-center gap-x-1.5 font-label text-[11px] text-foreground-500">
                <span>{formatViews(video.views)} 播放</span>
                <span className="text-foreground-300">·</span>
                <span>{formatDate(video.uploadTime)}</span>
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}